import React from "react";
import { Helmet } from "react-helmet-async";
import { SiteHeader } from "../components/layout/SiteHeader";
import { SiteFooter } from "../components/layout/SiteFooter";
import { Container } from "../components/layout/Container";

export function TechnologyPage() {
  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden bg-background-dark text-white">
      <Helmet>
        <title>Technology — How the Container Packing Algorithm Works | Feuteuristix</title>
        <meta name="description" content="The bin-packing and cost-optimisation engine behind Feuteuristix. How we select container combinations, plan 3D loads, and return results in milliseconds via API." />
        <meta property="og:title" content="Technology — How the Container Packing Algorithm Works | Feuteuristix" />
        <meta property="og:description" content="The bin-packing and cost-optimisation engine behind Feuteuristix. How we select container combinations, plan 3D loads, and return results in milliseconds via API." />
        <meta property="og:url" content="https://feuteuristix.com/technology" />
        <meta name="twitter:title" content="Technology — How the Container Packing Algorithm Works | Feuteuristix" />
        <meta name="twitter:description" content="The bin-packing and cost-optimisation engine behind Feuteuristix. How we select container combinations, plan 3D loads, and return results in milliseconds via API." />
        <link rel="canonical" href="https://feuteuristix.com/technology" />
      </Helmet>
      <SiteHeader />
      <main className="flex-1 pt-28 pb-16">
        <Container>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-8 md:p-12">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Technology</p>
            <h1 className="mt-4 text-4xl font-black leading-tight md:text-5xl">
              Intelligence engine for volume, weight, and route-aware planning.
            </h1>
            <p className="mt-5 max-w-3xl text-slate-300">
              Our platform combines optimization logic, operational rules, and dispatch constraints to produce practical plans your team
              can execute quickly on the ground.
            </p>

            <div className="mt-8 grid gap-4 md:grid-cols-2">
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Optimization Core</h3>
                <p className="mt-2 text-sm text-slate-300">Balances CBM, weight limits, stacking rules, and loading sequence constraints.</p>
              </div>
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Scenario Engine</h3>
                <p className="mt-2 text-sm text-slate-300">Evaluates every viable container combination to suggest the lowest-cost, highest-utilization plan.</p>
              </div>
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Operations Integration</h3>
                <p className="mt-2 text-sm text-slate-300">Supports warehouse and dispatch workflows with actionable plans, not just analytics.</p>
              </div>
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Live Performance Tracking</h3>
                <p className="mt-2 text-sm text-slate-300">Monitors utilization, trip efficiency, and SLA outcomes to drive continuous improvement.</p>
              </div>
            </div>
          </section>
        </Container>
      </main>
      <SiteFooter />
    </div>
  );
}
